export interface ActionItem {
  name: string;
  label: string;
  icon: string;
}
